import { Step } from './types';

interface StepIndicatorProps {
  step: Step;
  isAuthenticated: boolean;
}

export function StepIndicator({ step, isAuthenticated }: StepIndicatorProps) {
  const allSteps: { key: Step; label: string }[] = [
    { key: 'guest-info', label: 'Seus dados' },
    { key: 'seller', label: 'Vendedora' },
    { key: 'payment', label: 'Pagamento' },
    { key: 'confirm', label: 'Confirmar' },
  ];
  const steps = isAuthenticated ? allSteps.filter((s) => s.key !== 'guest-info') : allSteps;
  const currentIndex = steps.findIndex((s) => s.key === step);

  return (
    <div className="mb-4 sm:mb-6">
      <div className="flex items-center">
        {steps.map((s, idx) => (
          <div key={s.key} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div
                className={[
                  'w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-sm font-bold transition-colors',
                  idx < currentIndex
                    ? 'bg-olivine text-white'
                    : idx === currentIndex
                    ? 'bg-chocolate text-white shadow-md'
                    : 'bg-champagne-dark text-text-light',
                ].join(' ')}
              >
                {idx < currentIndex ? '✓' : idx + 1}
              </div>
              <span
                className={[
                  'text-[11px] sm:text-xs font-medium mt-1.5 text-center whitespace-nowrap',
                  idx === currentIndex ? 'text-text-dark font-semibold' : 'text-text-light',
                  idx !== currentIndex ? 'hidden sm:block' : '',
                ].join(' ')}
              >
                {s.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div className={[
                'h-0.5 flex-1 mx-2 sm:mx-3 rounded-full transition-colors',
                idx < currentIndex ? 'bg-olivine' : 'bg-champagne-dark',
              ].join(' ')} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
